import React from 'react'

export default function PreviewCashBack({ tableProps }) {
  return (
    <div className='flex flex-col px-8 gap-[20px]'>
      {!tableProps.is_fixed && (
        <>
      <div className='flex justify-between text-xl'>
        <div className=''> Start </div> <div className='text-black-900'>{tableProps.start}</div>
      </div>
      <div className='flex justify-between text-xl'>
        <div className=''> End </div> <div className='text-black-900'>{tableProps.end}</div>
      </div>
      </>
      )}
      <div className='flex justify-between text-xl'>
        <div className=''> Bonus Percentage </div> <div className='text-black-900'>{tableProps.bonus_percentage || tableProps.fixed_bonus}</div>
      </div>
      <div className='flex justify-between text-xl'>
        <div className=''>  Is fixed </div> <div className='text-black-900'>{tableProps.is_fixed === 1 ? 'Yes' : 'No'}</div>
      </div>
      <div className='flex justify-between text-xl'>
        <div className=''> Status </div> <div className='text-black-900'>{tableProps.status}</div>
      </div>
    </div>
  )
}
